define([
    'jquery',
    'underscore',
    '../../lead/services/leads',
    '../../directives/form',
    'jquery-migrate', // Needed for Foundation 5.5.3
    'foundation-sites',
], function ($, _) {
    'use strict';

    return {
        name: 'micrositeCtrl',
        arguments: [
            '$analytics',
            '$http',
            '$filter',
            '$rootScope',
            '$scope',
            '$state',
            '$stateParams',
            '$timeout',
            'googlePlacesApi',
            '$templateCache',
            'ErrorHandler',
            'Leads',
            function (
                $analytics,
                $http,
                $filter,
                $rootScope,
                $scope,
                $state,
                $stateParams,
                $timeout,
                google,
                $templateCache,
                ErrorHandler,
                Leads
            ) {
                $scope.myself = Leads.getMyself();
                $scope.myself.$promise.then(function (data) {
                    $scope.contactData = {
                        name: data.name,
                        email: data.email,
                        phone: data.phone,
                    };
                    $rootScope.bodyClass = $scope.page;
                    if (data.homeValue) {
                        if (data.homeValue.city) {
                            $rootScope.titleCity = data.homeValue.city;
                        }
                    }
                    var chartPoints = [];
                    var ticks = [];
                    if (data.homeValue && data.homeValue.prices) {
                        //Add all data to chartPoints and ticks
                        for (var i = 0; i < data.homeValue.prices.length; i++) {
                            var price = data.homeValue.prices[i];
                            var date = new Date(price.avmDate);
                            var point = {
                                c: [
                                    {
                                        v: date,
                                        f: $filter('date')(date, 'MMM yyyy'),
                                    },
                                ],
                            };
                            if ($scope.graphType != 'price') {
                                point.c.push({
                                    v: price.lowRange,
                                    f: '$' + $filter('number')(price.lowRange),
                                });
                            }
                            if ($scope.graphType != 'range') {
                                point.c.push({
                                    v: price.price,
                                    f: '$' + $filter('number')(price.price),
                                });
                            }
                            if ($scope.graphType != 'price') {
                                point.c.push({
                                    v: price.highRange,
                                    f: '$' + $filter('number')(price.highRange),
                                });
                            }
                            chartPoints.push(point);
                            ticks.push({
                                v: date,
                                f: $filter('date')(date, 'MMM'),
                            });
                        }
                        //sort chartPoints and ticks by date, newest to oldest
                        chartPoints.sort(function (a, b) {
                            if (a.c[0].v > b.c[0].v) {
                                return -1;
                            } else if (a.c[0].v < b.c[0].v) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                        ticks.sort(function (a, b) {
                            if (a.v > b.v) {
                                return -1;
                            } else if (a.v < b.v) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });

                        //remove first chartPoint and tick of a given month if there is more than one
                        var deDupedChartPoints = [chartPoints[0]];
                        var deDupedTicks = [ticks[0]];
                        for (var i = 1; i < chartPoints.length; i++) {
                            if (
                                chartPoints[i].c[0].f !=
                                chartPoints[i - 1].c[0].f
                            ) {
                                deDupedChartPoints.push(chartPoints[i]);
                                deDupedTicks.push(ticks[i]);
                            }
                        }
                        chartPoints = deDupedChartPoints;
                        ticks = deDupedTicks;

                        if (chartPoints.length > 8) {
                            //Grab the 8 most recent chartPoints and ticks
                            chartPoints = chartPoints.slice(0, 8);
                            ticks = ticks.slice(0, 8);
                        }
                        // Pad graph left and right
                        if (ticks[0]) {
                            var newDate = new Date(ticks[0].v);
                            newDate.setMonth(newDate.getMonth() + 1);
                            ticks.unshift({
                                v: newDate,
                                f: '',
                            });
                            var newDate = new Date(ticks[ticks.length - 1].v);
                            newDate.setMonth(newDate.getMonth() - 1);
                            ticks.unshift({
                                v: newDate,
                                f: '',
                            });
                        }
                    }

                    var cols = [
                        {
                            id: 'month',
                            label: 'Month',
                            type: 'date',
                            p: {},
                        },
                    ];
                    var colors = [];
                    var legend = 'bottom';
                    if ($scope.graphType != 'price') {
                        cols.push({
                            id: 'lowRange',
                            label: 'Low Range',
                            type: 'number',
                            p: {},
                        });
                        colors.push('#f65d58');
                    }
                    if ($scope.graphType != 'range') {
                        var label = 'Price Estimate';
                        if ($scope.graphType == 'price') {
                            label = '';
                            legend = 'none';
                        }
                        cols.push({
                            id: 'price',
                            label: label,
                            type: 'number',
                            p: {},
                        });
                        colors.push('#54bff7');
                    }
                    if ($scope.graphType != 'price') {
                        cols.push({
                            id: 'highRange',
                            label: 'High Range',
                            type: 'number',
                            p: {},
                        });
                        colors.push('#ffc136');
                    }

                    $scope.priceHistory = chartPoints.length;
                    $scope.priceHistoryChartData = {
                        type: 'LineChart',
                        displayed: true,
                        data: {
                            cols: cols,
                            rows: chartPoints,
                        },
                        options: {
                            curveType: 'function',
                            height: 260,
                            chartArea: {
                                top: 24,
                                left: 100,
                            },
                            pointShape: 'circle',
                            pointSize: 12,
                            backgroundColor: '#e9e9e9',
                            colors: colors,
                            hAxis: {
                                baselineColor: 'transparent',
                                gridlines: {
                                    color: 'transparent',
                                },
                                maxAlternation: 1, // use a maximum of 1 line of labels
                                textStyle: {
                                    color: 'black',
                                    fontSize: 16,
                                },
                                ticks: ticks,
                            },
                            legend: {
                                alignment: 'start',
                                position: legend,
                                textStyle: {
                                    color: '#9C9C9C',
                                    fontSize: 14,
                                },
                            },
                            vAxis: {
                                baselineColor: 'transparent',
                                gridlines: {
                                    color: '#c2c2c2',
                                    count: 5,
                                },
                                textStyle: {
                                    color: '#9a9a9a',
                                    fontSize: 16,
                                },
                                format: '$#,###',
                            },
                        },
                        formatters: {},
                    };
                    $scope.priceHistoryChartDataPrint = jQuery.extend(
                        true,
                        {},
                        $scope.priceHistoryChartData
                    );
                    $scope.priceHistoryChartDataPrint.options.width = 800;
                    $scope.priceHistoryChartDataPrint.options.legend.position =
                        'right';
                    $scope.priceHistoryChartDataPrint.options.chartArea.left =
                        '15%';
                    $scope.priceHistoryChartDataPrint.options.chartArea.width =
                        '65%';
                    $scope.priceHistoryChartDataPrint.options.chartArea.height =
                        '75%';
                });
                $scope.autocompleteOptions = {
                    types: ['address'],
                };
                if (agentLoc) {
                    if (agentLoc.lat && agentLoc.lng) {
                        $scope.autocompleteOptions.bounds = new google.maps.LatLngBounds(
                            new google.maps.LatLng(agentLoc.lat, agentLoc.lng)
                        );
                    }
                    if (agentLoc.country) {
                        $scope.autocompleteOptions.componentRestrictions = {
                            country: agentLoc.country,
                        };
                    }
                }

                var lastPredictions = false;
                $scope.$on('g-places-autocomplete:predictions', function (
                    event,
                    predictions
                ) {
                    lastPredictions = predictions;
                });

                $scope.submitAddressLoader = false;
                $scope.submitAddress = function (e, form) {
                    $scope.submitAddressLoader = true;
                    form.serverErrors = '';
                    if (_.has($scope.address, 'formatted_address')) {
                        $scope.myself.address =
                            $scope.address.formatted_address;
                        $scope.toGoNextStep();
                        $timeout(function () {
                            /**
                             * This request can take several seconds.
                             * It's in this timeout so the user can get to the next
                             * page while it works in the background.
                             */
                            $scope.saveMyself(form, true);
                        }, 100);
                    } else if (
                        !lastPredictions ||
                        lastPredictions.length == 0
                    ) {
                        $scope.submitAddressLoader = false;
                        form.serverErrors = [
                            'Please enter your address including the zip code and try again.',
                        ];
                    } else {
                        $scope.submitAddressLoader = false;
                        form.serverErrors = [
                            'Please choose an address from the dropdown below.',
                        ];
                        $scope.$broadcast(
                            'g-places-autocomplete:parse',
                            $scope.address
                        );
                    }
                };

                $scope.toGoNextStep = function (trackLead) {
                    var promise;

                    // Check for skipping
                    if (
                        $scope.nextStep == 'property_info' &&
                        $scope.skipPropertyInfoMobile &&
                        Foundation.utils.is_small_only()
                    ) {
                        $scope.nextStep = $scope.propertyInfoNextStep;
                    }

                    if ($scope.nextStep == 'report') {
                        // Send admin notifications
                        $http.get(
                            $rootScope.Routing.generate('lead_notify_admin', {
                                _format: 'json',
                            })
                        );
                        // Clear cache, so we're always grabbing a current report
                        $templateCache.remove(
                            $rootScope.Routing.generate('report_partial')
                        );
                        if ($stateParams.forcedCity) {
                            promise = $state.go('leadReport_with_city', {
                                leadId: $scope.myself.id,
                                forcedCity: $stateParams.forcedCity,
                                addressUrl: $scope.myself.addressUrl,
                            });
                        } else {
                            promise = $state.go('leadReport', {
                                leadId: $scope.myself.id,
                                addressUrl: $scope.myself.addressUrl,
                            });
                        }
                    } else {
                        if ($scope.nextStep == 'confirmation') {
                            // Send admin notifications
                            $http.get(
                                $rootScope.Routing.generate(
                                    'lead_notify_admin',
                                    { _format: 'json' }
                                )
                            );
                        }
                        if ($stateParams.forcedCity) {
                            promise = $state.go(
                                $scope.nextStep + '_with_city',
                                { forcedCity: $stateParams.forcedCity }
                            );
                        } else {
                            promise = $state.go($scope.nextStep);
                        }
                    }

                    if (promise && trackLead) {
                        /* Send analytics event if the user has an email
                        address, but only after the new page has loaded */
                        if ($scope.myself.email && !emailTracked) {
                            promise.then(function () {
                                $analytics.eventTrack('email_submitted', {
                                    category: 'user_action',
                                    label: 'Email Address Entered',
                                });
                                if (
                                    window.hasFacebookPixel &&
                                    typeof fbq == 'function'
                                ) {
                                    fbq('track', 'Lead');
                                    $scope.$emit('facebookTracked', true);
                                } else if (window.addFacebookPixel) {
                                    window.addFacebookPixel(true);
                                    fbq('track', 'Lead');
                                    $scope.$emit('facebookTracked', true);
                                    $scope.$emit('facebookTracked', false);
                                }
                            });
                            emailTracked = true;
                        }
                    }
                };

                var emailTracked = $scope.myself.email;
                $scope.saveMyself = function (form, noAutoNavigation) {
                    if (form) {
                        form.submitted = true;
                    }
                    if (!form || form.$valid) {
                        var success = true;
                        // Clone object, so $scope.myself can continue to be operated on while saving
                        var toSave = angular.copy($scope.myself);

                        toSave
                            .save()
                            .catch(function (result) {
                                if (form) {
                                    form.serverErrors = ErrorHandler.getMessage(
                                        result,
                                        'Error saving contact.  Please try again'
                                    );
                                }
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    Object.assign($scope.myself, toSave);

                                    if (form) {
                                        form.submitted = false;
                                        form.serverErrors = false;
                                    }

                                    if (!noAutoNavigation) {
                                        $scope.toGoNextStep(true);
                                    }
                                }
                            });
                    }
                };

                $scope.submitContactForm = function (form) {
                    if (form) {
                        form.submitted = true;
                        form.serverErrors = false;
                    }
                    if (!form || form.$valid) {
                        var success = true;

                        $http
                            .post(
                                $rootScope.Routing.generate('contact_user', {
                                    _format: 'json',
                                }),
                                $scope.contactData
                            )
                            .catch(function (result) {
                                if (form) {
                                    form.serverErrors = ErrorHandler.getMessage(
                                        result,
                                        'Error saving contact.  Please try again'
                                    );
                                }
                                success = false;
                            })
                            .then(function (result) {
                                if (success) {
                                    if (form) {
                                        form.submitted = false;
                                        form.serverErrors = false;
                                        form.success = true;
                                    }
                                }
                            });
                    }
                };
                $scope.$watch('myself.homeValue.latitude', function (newValue) {
                    if (newValue) {
                        var startingCenter = {
                            latitude: $scope.myself.homeValue.latitude,
                            longitude: $scope.myself.homeValue.longitude,
                        };
                        $scope.map = {
                            center: startingCenter,
                            zoom: 18,
                            events: {
                                tilesloaded: function (map, eventName, args) {
                                    google.maps.event.trigger(map, 'resize');
                                },
                            },
                            options: {
                                mapTypeId: 'satellite',
                                scrollwheel: false,
                            },
                        };
                    }
                });
            },
        ],
    };
});
